'use client';

import React from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import CheckedBlue from '../icons/Checked.blue';

const Dot = () => {
  return (
    <div className="h-[20px] mt-[2px] w-fit flex items-center justify-center">
      <CheckedBlue />
    </div>
  );
};

export default function CustomerBenefit() {
  const {i18nHelper: { t }} = useGlobalClientContext();
  
  return (
    <div className="w-full h-fit bg-gray-50 py-[120px] flex flex-col items-center justify-center">
      <div className="w-fit flex flex-col items-start justify-center gap-[80px]">
        <div className="flex flex-col items-start justify-center">
          <div className="font-display font-semibold text-xl leading-3xl text-cic-blue-500">
            {t('home.customer_benefit.title', {})}
          </div>
          <div className="mt-l font-display font-semibold text-4xl leading-18xl text-primary">
            {t('home.customer_benefit.description', {})} <br /> 
            {t('home.customer_benefit.description2', {})}
          </div>
          <div className="mt-4xl font-regular text-xl leading-3xl text-gray-600">
            {t('home.customer_benefit.description3', {})}
            <br />
            {t('home.customer_benefit.description4', {})}
          </div>
        </div>
        <div className="flex flex-row items-start justify-center gap-[36px]">
          <div className="max-w-[378px] flex flex-col justify-start items-start gap-[16px]">
            <div className="font-semibold text-xl leading-3xl text-primary">
              {t('home.customer_benefit.reduce_infrastructure_overhead', {})}
            </div>
            <ul className="blue-dot-list space-y-[8px]">
              <li className="flex flex-row justify-start items-start gap-[8px]">
                <Dot />
                <span className="font-regular text-md leading-xl text-gray-600">
                  {t('home.customer_benefit.reduce_infrastructure_overhead.description', {})}
                </span>
              </li>
              <li className="flex flex-row justify-start items-start gap-[8px]">
                <Dot />
                <span className="font-regular text-md leading-xl text-gray-600">
                {t('home.customer_benefit.reduce_infrastructure_overhead.description2', {})}
                </span>
              </li>
            </ul>
          </div>
          <div className="px-[36px]">
            <div className="max-w-[378px] flex flex-col justify-start items-start gap-[16px]">
              <div className="font-semibold text-xl leading-3xl text-primary break-words text-wrap">
                {t('home.customer_benefit.accelerate_ai_development_cycle', {})}
              </div>
              <ul className="blue-dot-list space-y-[8px]">
                <li className="flex flex-row justify-start items-start gap-[8px]">
                  <Dot />
                  <span className="font-regular text-md leading-xl text-gray-600">
                    {t('home.customer_benefit.accelerate_ai_development_cycle.description', {})}
                  </span>
                </li>
                <li className="flex flex-row justify-start items-start gap-[8px]">
                  <Dot />
                  <span className="font-regular text-md leading-xl text-gray-600">
                    {t('home.customer_benefit.accelerate_ai_development_cycle.description2', {})}
                  </span>
                </li>
                <li className="flex flex-row justify-start items-start gap-[8px]">
                  <Dot />
                  <span className="font-regular text-md leading-xl text-gray-600">
                    {t('home.customer_benefit.accelerate_ai_development_cycle.description3', {})}
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="max-w-[378px] flex flex-col justify-start items-start gap-[16px]">
            <div className="font-semibold text-xl leading-3xl text-primary">
              {t('home.customer_benefit.simplify_ai_operations', {})}
            </div>
            <ul className="blue-dot-list space-y-[8px]">
              <li className="flex flex-row justify-start items-start gap-[8px]">
                <Dot />
                <span className="font-regular text-md leading-xl text-gray-600">
                  {t('home.customer_benefit.simplify_ai_operations.description', {})}
                </span>
              </li>
              <li className="flex flex-row justify-start items-start gap-[8px]">
                <Dot />
                <span className="font-regular text-md leading-xl text-gray-600">
                  {t('home.customer_benefit.simplify_ai_operations.description2', {})}
                  <br/>
                  {t('home.customer_benefit.simplify_ai_operations.description3', {})}
                </span>
              </li>
              <li className="flex flex-row justify-start items-start gap-[8px]">
                <Dot />
                <span className="font-regular text-md leading-xl text-gray-600">
                  {t('home.customer_benefit.simplify_ai_operations.description4', {})}
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
